import { questNumberLabel, questPath, type JobQuest } from "../types";
import { QuestObjectives } from "./QuestObjectives";
import { QuestStatus, RankBadge } from "./QuestPrimitives";
import { PaperPins } from "./QuestPaperDecor";

export function QuestBrief({ quest }: { quest: JobQuest }) {
  return (
    <aside className="jq-brief jq-paper" aria-labelledby="incoming-quest-title">
      <PaperPins />
      <div className="jq-paper-caption">
        <span>QUEST REQUEST</span>
        <span>企業からの依頼書</span>
      </div>
      <div className="jq-brief-body">
        <div className="jq-card-meta">
          <p className="jq-eyebrow">
            QUEST #{questNumberLabel(quest.questNumber)}
          </p>
          <QuestStatus quest={quest} />
        </div>
        <div className="jq-brief-title">
          <div>
            <p className="jq-company">依頼主 / {quest.company}</p>
            <h2 id="incoming-quest-title">{quest.title}</h2>
          </div>
          <RankBadge rank={quest.rank} />
        </div>
        <QuestObjectives objectives={quest.objectives} compact />
        <div className="jq-brief-reward">
          <span>REWARD / 報酬</span>
          <strong>{quest.reward}</strong>
        </div>
        <a className="jq-button" href={questPath(quest.questNumber)}>
          依頼書を開く<span aria-hidden="true">↗</span>
        </a>
      </div>
      <div className="jq-paper-caption">
        <span>CONTRACT / 業務委託</span>
        <span>{quest.target}</span>
      </div>
    </aside>
  );
}
